import type {
  IImageReplaceRule,
  IImageReplaceWithVariableRule,
} from '@carboncopyco/types';
import { EditControls, type EditControlsProps } from './EditControls';

export type ImageReplaceControlsProps = EditControlsProps<
  IImageReplaceRule | IImageReplaceWithVariableRule
>;

export const ImageReplaceControls = ({
  onSubmit,
  rule,
  onCancel,
  autoFocus,
  onFocus,
}: ImageReplaceControlsProps) => {
  if (rule) {
    return (
      <EditControls
        onSubmit={onSubmit}
        rule={rule}
        onCancel={onCancel}
        autoFocus={autoFocus}
        onFocus={onFocus}
      />
    );
  }

  // We don't support creation of image F&R rules from the manager.
  // The manager can only instruct the engine to initiate the creation flow.
  return null;
};
